import React from "react";
import { useSelector } from "react-redux";
import { format } from 'date-fns';
import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Typography,
} from "@material-ui/core";

import { getArchivosSubidos } from "../../redux/selectors";
import styles from "../GrillaAdjuntos/styles.styles";

export default () => {
  const classes = styles();
  const archivos = useSelector((state) => getArchivosSubidos(state));

  const mostrarArchivos = () => {
    return archivos.map((archivo : File) => (
      <TableRow key={archivo.name}>
        <TableCell className={classes.celdaFecha}>{format(new Date(),'dd/MM/yyyy')}</TableCell>
        <TableCell className={classes.celdaTabla} align='left'>{archivo.name}</TableCell>
      </TableRow>
    ));
  };

  return (
    <Container disableGutters={true}>
      <Typography
        color="textPrimary"
        className={classes.tableTitle}
        style={
          archivos.length === 0 ? { display: "none" } : { display: "flex" }
        }
      >
        Archivos Subidos
      </Typography>
      <TableContainer>
        <Table aria-label="tabla adjuntos" padding="default">
          <TableBody>{mostrarArchivos()}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};